import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import StatusThumbHtmlView from './StatusHtml';
import StatusThumbReactView from './Status';
const StatusThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(StatusThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(StatusThumbReactView, _extends({}, props));
};
StatusThumbView.displayName = 'StatusThumbView';
export default StatusThumbView;
